import { isVersionedObject } from '@refinio/one.core/lib/object-recipes.js';
import { storeUnversionedObject } from '@refinio/one.core/lib/storage-unversioned-objects.js';
import { storeVersionedObjectNoMerge } from '@refinio/one.core/lib/storage-versioned-objects.js';
import { isHash } from '@refinio/one.core/lib/util/type-checks.js';
import { linkedListMergeSingleElement } from './merge.js';
async function storeAnyObjectOrHash(objOrHash) {
    if (isHash(objOrHash)) {
        return objOrHash;
    }
    if (isVersionedObject(objOrHash)) {
        return (await storeVersionedObjectNoMerge(objOrHash)).hash;
    }
    else {
        return (await storeUnversionedObject(objOrHash)).hash;
    }
}
/**
 * Insert a new element at the correct position in the linked list.
 *
 * @param linkedList
 * @param dataOrHash
 * @param metaDataOrHashes
 * @param timestamp
 */
export async function linkedListInsert(linkedList, dataOrHash, metaDataOrHashes, timestamp) {
    const dataHash = await storeAnyObjectOrHash(dataOrHash);
    // Write creation time meta information
    const creationTimeResult = await storeUnversionedObject({
        $type$: 'CreationTime',
        timestamp: timestamp ? timestamp : Date.now(),
        data: dataHash
    });
    let metaDataHashes = undefined;
    if (metaDataOrHashes) {
        if (!Array.isArray(metaDataOrHashes)) {
            metaDataOrHashes = await metaDataOrHashes(creationTimeResult);
        }
        metaDataHashes = await Promise.all(metaDataOrHashes.map(storeAnyObjectOrHash));
    }
    const newListEntry = {
        creationTimeHash: creationTimeResult.hash,
        creationTime: creationTimeResult.obj.timestamp,
        metaDataHashes
    };
    return linkedListMergeSingleElement(linkedList, newListEntry);
}
//# sourceMappingURL=insert.js.map